import { useEffect, useRef, useState } from 'react';

const POLL_MS = 5 * 60 * 1000;

/**
 * Észleli, ha a szerveren új build van telepítve: az asset-manifest.json-ben
 * lévő main.js hash-változás jelzi az új verziót. Új verziónál egy sávot mutat,
 * amivel a felhasználó egy kattintással frissítheti az oldalt.
 */
export default function VersionChecker() {
  const [newVersion, setNewVersion] = useState(false);
  const baselineRef = useRef(null);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') return;

    const check = async () => {
      try {
        const res = await fetch(`./asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const current = data.files && data.files['main.js'];
        if (!current) return;
        if (baselineRef.current === null) {
          baselineRef.current = current;
        } else if (current !== baselineRef.current) {
          setNewVersion(true);
        }
      } catch {
        // hálózati hiba esetén nem csinálunk semmit, a következő kör újra megpróbálja
      }
    };

    check();
    const timer = setInterval(check, POLL_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!newVersion) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
      background: '#1976d2', color: '#fff',
      padding: '12px 16px', fontSize: '14px', fontWeight: 600,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.3)'
    }}>
      <span>🔄 Új verzió érhető el az alkalmazásból.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '6px',
          color: '#fff', padding: '6px 16px', fontWeight: 700, cursor: 'pointer', fontSize: '14px'
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)' }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)' }}
      >
        Frissítés
      </button>
    </div>
  );
}
